<template>
  <div class="top-lay">
    <div>      
      <div class="tag-group" style="margin-bottom:20px;">
        <span class="tag-group__title" style="margin-right: 8px;float: left; line-height: 35px; color: #666; ">日期</span>
        <el-radio-group v-model="departureDate" @change="btnClick($event,'departureDate')" size="medium">
          <el-radio-button 
            v-for="item in lastSevenDays"
            :key="item.id"
            :label="item.dateValue" >
            {{ item.dateValue }}
          </el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="departureDate"
          type="date"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="(value) => btnClick(value, 'departureDatePicker')"
          style="width:135px;"
          format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </div>
    </div>
    <div class="tag-group" style="margin-bottom:-20px;">
      <span class="tag-group__title" style="line-height: 35px; color: #666;margin-right:8px;float:left;} ">线路</span>
      <el-radio-group v-model="busLinesId" @change="btnClick($event,'busLinesId')" size="medium" style="float:left;">
        <el-radio-button 
          v-for="item in busLinesList"
          :key="item.id"
          :label="item.id">
          {{ item.lineName }}
        </el-radio-button>
      </el-radio-group>
      <span v-if="buttonList!=null&&buttonList.length>0" class="toolbar" >
        <el-form :inline="true" @submit.native.prevent>            
          <!-- 这个就是当前页面内，所有的btn列表 -->
          <el-form-item v-for="item in buttonList" v-bind:key="item.id">
            <!-- 这里触发点击事件 -->
            <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide && item.name !='编辑排班操作日记'" @click="callFunc(item)">{{item.name}}</el-button>
          </el-form-item>
        </el-form>
      </span>
    </div>
  </div>
</template>

<script>
import { getBusLinesListPage } from "../../api/api";
import { currentNextDate,formatDate } from '../../baseCommon.js';
  
export default {
  name: "EveryDaySchedulingToolbar",
  data () {
    return {
      busLinesList: [], //线路列表
      busLinesId: '',
      lastSevenDays:[], //最近七天日期集
      departureDate:'',
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime(); // - 86400000
        }
      },
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      let itemExt = {};
      if(item !== null){
        itemExt = item;
      }
      itemExt.busLinesId = this.busLinesId;
      itemExt.departureDate = this.departureDate;
      this.$emit("callFunction", itemExt); //将值传给父组件
    },
    btnClick(value,type){
      if(type === "departureDate"){
        this.departureDate = value;
      } else if(type === "departureDatePicker"){
        this.departureDate = formatDate(value);
      } else{
        this.busLinesId = value;
      }
      this.callFunc(null);
    },
    getBusLinesList(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLinesList = [];
        this.busLinesId = '';
        if(res.data.response.dataCount > 0){
          for (let i = 0; i < res.data.response.dataCount; i++) {
            let busLinesDataObj = {};
            busLinesDataObj.id = res.data.response.data[i].Id;
            busLinesDataObj.type = i===0?'primary':'';
            busLinesDataObj.lineName = res.data.response.data[i].LineChineseName;
            this.busLinesList.push(busLinesDataObj);
            if(i===0){
              this.busLinesId = busLinesDataObj.id;            
            }
          }
        }
      });
    },
    // 明天起，最近N天
    getLatelyNDate(n){
      this.lastSevenDays = [];
      this.departureDate = '';
      for (let i = 1; i <= n; i++) {
        let dateDataObj = {};
        dateDataObj.id = i;
        dateDataObj.type = i===1?'primary':'';
        dateDataObj.dateValue = currentNextDate(i);
        this.lastSevenDays.push(dateDataObj);
        if(i===1){
          this.departureDate = dateDataObj.dateValue;
        }
      }
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLinesList(pageSizePara);
    this.getLatelyNDate(7); 
  }
}
</script>
<style scoped>
.top-lay{
  margin-left:5px;
  margin-bottom:35px; 
  margin-top: 10px; 
}
</style>